<script setup lang="ts">
import { EntityNewsSidebarItem, type TNewsSidebarItem } from '~/components/entity/news'
import type { IResponseData } from '~/types'
import type { IProps } from './types'

const { t } = useI18n()

const props = withDefaults(defineProps<IProps>(), {
  path: '/news',
  variant: 'default'
})

const headingText = computed(() => props.heading || t('widget.sidebar.news_heading'))

const url = computed(() => useUrlWithParams(props.path, props.queryParams))

const { data: news } = useApi<IResponseData<TNewsSidebarItem[]>>(() => url.value, {
  key: `sidebar-news.${url.value}`
})

const isKyrgyzCategory = computed(() => {
  return props.queryParams?.['filter[category]'] === 'kyrgyzcha'
})

const isCryptoCategory = computed(() => {
  return props.queryParams?.['filter[category]'] === 'crypto'
})

const isMoneyTransfersCategory = computed(() => {
  return props.queryParams?.['filter[category]'] === 'money-transfers'
})

const filteredNews = computed(() => {
  if (!news.value?.data) return []
  if (!props.news_id) return news.value.data
  return news.value.data.filter((item) => item.id !== props.news_id)
})
</script>

<template>
  <SidebarBlock v-if="filteredNews.length" :heading-text="headingText" :variant="props.variant">
    <div>
      <EntityNewsSidebarItem
        v-for="item in filteredNews"
        :id="item.id"
        :key="item.id"
        :title="item.title"
        :slug="item.slug"
        :url="item.url"
        :type="item.type"
        :publication_datetime="item.publication_datetime"
      />
    </div>
    <footer class="text-right">
      <Button as-child>
        <NuxtLinkLocale v-if="isKyrgyzCategory" to="/news/category/kyrgyzcha">
          Бардык жаңылыктар
        </NuxtLinkLocale>
        <NuxtLinkLocale v-else-if="isCryptoCategory" to="/news/category/crypto">{{
          $t('widget.sidebar_news.crypto_news')
        }}</NuxtLinkLocale>
        <NuxtLinkLocale v-else-if="isMoneyTransfersCategory" to="/news/category/money-transfers">{{
          $t('widget.sidebar_news.money_transfers')
        }}</NuxtLinkLocale>
        <NuxtLinkLocale v-else to="/news">{{ $t('widget.sidebar_news.all_news') }}</NuxtLinkLocale>
      </Button>
    </footer>
  </SidebarBlock>
</template>
